import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import {
  NotificationPayload,
  showNotification,
} from '../../../../features/notifications'
import { GiftOrder, GiftOrdersRequest, GiftOrdersResponse } from './types'

const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'orderDate') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}
export const giftOrdersListMounted = createEvent<GiftOrdersRequest>()

export const getGiftOrders = fx<GiftOrdersRequest, GiftOrdersResponse>({
  method: 'GET',
  url: `/giftshop/gift_order`,
})

export const $giftOrders = restore<GiftOrder[]>(
  getGiftOrders.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfGiftOrders = restore(
  getGiftOrders.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: giftOrdersListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy === 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
      populate: JSON.stringify(['Gift.giftType']),
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getGiftOrders,
})

sample({
  clock: getGiftOrders.failData,
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})
